import React, { useEffect, useState } from "react";

import MobileMenuDefaultCompact from "./MobileMenuDefaultCompact";
import MobileMenuDefaultFull from "./MobileMenuDefaultFull";
import { isBrowser, getDefaultScrollConfig } from "../../helpers";

const STICKY_TRIGGER = 50; // Pixel passes from the trigger before activate sticky
const SCROLL_OFFSET = (30 / 100) * (isBrowser() ? window.innerHeight : 0); // Offset before trigger scroll handler. 30% of view port
const listenerConfig = getDefaultScrollConfig();

function MobileMenuDefault() {
  /**
   * Sticky handler
   */
  const [isSticky, setSticky] = useState(false);

  useEffect(() => {
    const header = document.getElementById("stickyTrigger");
    const sticky = header.offsetTop + STICKY_TRIGGER;
    const listener = () => {
      if (window.scrollY > sticky) {
        if (!isSticky) {
          setSticky(true);
        }
      } else {
        header.classList.remove("sticky");
        if (isSticky) {
          setSticky(false);
        }
      }
    };

    window.addEventListener("scroll", listener, listenerConfig);
    return () => {
      window.removeEventListener("scroll", listener);
    };
  }, [isSticky]);

  /**
   * Scroll handler
   */
  const [scrollDir, setScrollDir] = useState(null);

  useEffect(() => {
    const threshold = SCROLL_OFFSET;
    let lastScrollY = window.scrollY;
    let ticking = false;

    const updateScrollDir = () => {
      const mouseScrollY = window.scrollY;

      if (Math.abs(mouseScrollY - lastScrollY) < threshold) {
        ticking = false;
        return;
      }
      setScrollDir(mouseScrollY > lastScrollY ? "down" : "up");
      lastScrollY = mouseScrollY > 0 ? mouseScrollY : 0;
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDir);
        ticking = true;
      }
    };

    window.addEventListener("scroll", onScroll, listenerConfig);

    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollDir]);

  return (
    <>
      <MobileMenuDefaultFull />
      <MobileMenuDefaultCompact isSticky={isSticky} scrollDir={scrollDir} />
      <div id="stickyTrigger" />
    </>
  );
}

export default MobileMenuDefault;
